import { useEffect, useState } from "react";

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={scrollToTop}
      aria-label="返回顶部"
      className="fixed bottom-6 right-5 z-40 w-11 h-11 flex items-center justify-center rounded-full bg-foreground-950 text-background-50 transition-colors duration-200 hover:bg-primary-600 cursor-pointer"
    >
      <i className="ri-arrow-up-line text-lg" />
    </button>
  );
}